// extracted by mini-css-extract-plugin
module.exports =  {"week":"_93444fe79c--week--EMD1E"};